import { Suspense } from 'react'
import { Redirect, Route, Switch, useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import Loader from '../Loader'
import { ROUTES } from 'routes/paths'
import Page404 from 'components/Page404'
import { GTM_SEARCH_PARAMS_KEYS } from 'app/utils'
import { getCurrentUserTypeByRole, getUrlParams } from 'utils'
import { STATUS_FLAGS } from 'utils/constants/flags'
import { indexRoutes } from 'routes'

const MainAppRoutes = ({
  displayEdubookLegalConditions,
  displayPublisherLegalConditions,
  userResetPassword,
  userRole,
}) => {
  const { push } = useHistory()
  const userRoutes = indexRoutes.filter(({ urlRole }) =>
    urlRole.includes(userRole)
  )
  const { isRelative, isTeacher } = getCurrentUserTypeByRole(userRole)
  const resetPassword = userResetPassword === STATUS_FLAGS.TRUE
  const redirectToDashboard = () => {
    const utmParams = {
      [GTM_SEARCH_PARAMS_KEYS.UTM_SOURCE]: getUrlParams(
        GTM_SEARCH_PARAMS_KEYS.UTM_SOURCE
      ),
      // eslint-disable-next-line sort-keys
      [GTM_SEARCH_PARAMS_KEYS.UTM_MEDIUM]: getUrlParams(
        GTM_SEARCH_PARAMS_KEYS.UTM_MEDIUM
      ),
      // eslint-disable-next-line sort-keys
      [GTM_SEARCH_PARAMS_KEYS.UTM_CAMPAIGN]: getUrlParams(
        GTM_SEARCH_PARAMS_KEYS.UTM_CAMPAIGN
      ),
    }
    const getCurrentRoute = (originalRoute) => {
      if (Object.values(utmParams).every((value) => !!value)) {
        const queryString = Object.entries(utmParams)
          .map(([key, value]) => `${key}=${value}`)
          .join('&')

        return `${originalRoute}?${queryString}`
      } else {
        return originalRoute
      }
    }
    if (isTeacher) {
      return getCurrentRoute(ROUTES.HOME)
    }
    if (isRelative) {
      return getCurrentRoute(ROUTES.STUDENTS)
    }
    return getCurrentRoute(ROUTES.BOOKS)
  }

  const checkLegalConditions = () => {
    if (resetPassword) return <Redirect to={ROUTES.RESET_PASSWORD} />

    if (displayPublisherLegalConditions)
      return <Redirect to={ROUTES.PUBLISHER_LEGAL_CONDITIONS} />
    return (
      displayEdubookLegalConditions && (
        <Redirect to={ROUTES.EDUBOOK_LEGAL_CONDITIONS} />
      )
    )
  }

  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route exact path={ROUTES.BASE}>
          <Redirect to={redirectToDashboard()} />
        </Route>
        {userRoutes?.map(({ component: Component, path }) => (
          <Route
            exact={!path.includes(ROUTES.TASKS)}
            key={path}
            path={path}
            render={({ location }) => {
              if (location.pathname === ROUTES.EDUBOOK_LEGAL_CONDITIONS) {
                return displayEdubookLegalConditions ? (
                  <Component />
                ) : (
                  <Redirect to={ROUTES.BASE} />
                )
              }
              if (location.pathname === ROUTES.PUBLISHER_LEGAL_CONDITIONS) {
                return displayPublisherLegalConditions ? (
                  <Component />
                ) : (
                  <Redirect to={ROUTES.BASE} />
                )
              }
              if (location.pathname === ROUTES.RESET_PASSWORD) {
                return resetPassword ? (
                  <Component />
                ) : (
                  <Redirect to={ROUTES.BASE} />
                )
              }
              return displayEdubookLegalConditions ||
                displayPublisherLegalConditions ? (
                checkLegalConditions()
              ) : (
                <Component />
              )
            }}
          />
        ))}

        <Route
          render={() =>
            resetPassword ? (
              <Redirect path='*' to={ROUTES.RESET_PASSWORD} />
            ) : (
              <Page404 goTo={() => push(ROUTES.BASE)} />
            )
          }
        />
        <Route
          render={() =>
            displayEdubookLegalConditions ? (
              <Redirect path='*' to={ROUTES.EDUBOOK_LEGAL_CONDITIONS} />
            ) : (
              <Page404 goTo={() => push(ROUTES.BASE)} />
            )
          }
        />
        <Route
          render={() =>
            displayPublisherLegalConditions ? (
              <Redirect path='*' to={ROUTES.PUBLISHER_LEGAL_CONDITIONS} />
            ) : (
              <Page404 goTo={() => push(ROUTES.BASE)} />
            )
          }
        />
      </Switch>
    </Suspense>
  )
}

MainAppRoutes.propTypes = {
  displayEdubookLegalConditions: PropTypes.bool.isRequired,
  displayPublisherLegalConditions: PropTypes.bool.isRequired,
  userResetPassword: PropTypes.string.isRequired,
  userRole: PropTypes.string.isRequired,
}

export default MainAppRoutes
